import type { InputHTMLAttributes, ReactNode, SelectHTMLAttributes } from 'react'

const control =
  'mt-1 block w-full rounded-lg border border-gray-300 bg-white px-2.5 py-1.5 text-sm text-gray-800 ' +
  'shadow-sm transition focus:border-ds-500 focus:outline-none focus:ring-2 focus:ring-ds-500/20'

export function Select({
  label,
  className = '',
  children,
  ...props
}: SelectHTMLAttributes<HTMLSelectElement> & { label?: string }) {
  return (
    <label className="block text-xs font-medium text-gray-500">
      {label}
      <select className={`${control} ${className}`} {...props}>
        {children}
      </select>
    </label>
  )
}

export function Input({
  label,
  className = '',
  ...props
}: InputHTMLAttributes<HTMLInputElement> & { label?: string }) {
  return (
    <label className="block text-xs font-medium text-gray-500">
      {label}
      <input className={`${control} ${className}`} {...props} />
    </label>
  )
}

export function Field({ label, children }: { label: string; children: ReactNode }) {
  return (
    <label className="block text-xs font-medium text-gray-500">
      {label}
      {children}
    </label>
  )
}
